import { useFeatureIsOn } from '@growthbook/growthbook-react';
import React from 'react';
import { UserInfo } from '@/account/Interfaces';
import { Text, Box, Link } from '@/theme/index';
import { useRedirect } from '@/utils/hooks/useRedirect';
import { useScreenSize } from '@/utils/useScreenSize';
import { TooltipMenuItem } from '../TooltipMenuItem/TooltipMenuItem';

interface UserInformationProps {
  user: UserInfo | null;
}

export function UserInformation({ user }: UserInformationProps) {
  const { redirect } = useRedirect();
  const { isDesktop } = useScreenSize();
  const manageMyAccount = useFeatureIsOn('prop-2232');

  const handleClick = () => {
    redirect('/dashboard/billing');
  };

  if (!user) return null;

  return (
    <div>
      <Text variant="h2" data-cy="user_name">
        {user.first_name} {user.last_name}
      </Text>

      <Box sx={{ display: 'flex' }} data-cy="user_code">
        <strong>Member ID:</strong>
        <TooltipMenuItem text={user.user_code} />
      </Box>

      <Box sx={{ display: 'flex' }} data-cy="user_email">
        <strong>Email:</strong>
        <TooltipMenuItem text={user.email} />
      </Box>

      {isDesktop && manageMyAccount ? (
        <Link
          color="inherit"
          onClick={handleClick}
          mt={1}
          sx={{
            textDecoration: 'none',
            '&:hover': {
              textDecoration: 'underline',
            },
          }}
        >
          <strong>Manage My Account</strong>
        </Link>
      ) : null}
    </div>
  );
}
